import * as React from 'react';
import { AlertTriangle, ChevronLeft, ChevronRight } from 'lucide-react';

export interface MismatchBannerProps {
	currentIndex: number;
	total: number;
	isReverifying?: boolean;
	onReverify: () => void;
	onPrev: () => void;
	onNext: () => void;
}

export const MismatchBanner: React.FC<MismatchBannerProps> = ({
	currentIndex,
	total,
	// isReverifying = false,
	// onReverify,
	onPrev,
	onNext,
}) => {
	const isFirst = currentIndex <= 0;
	const isLast = currentIndex >= total - 1;

	return (
		<div
			role="status"
			className="flex flex-wrap items-center gap-3 rounded-lg bg-amber-500/10 border border-amber-500/30 px-4 py-3"
		>
			<div className="flex min-w-0 flex-1 items-center gap-2">
				<AlertTriangle className="size-4 shrink-0 text-[#BB4D00]" aria-hidden />
				<p className="text-sm font-semibold text-[#BB4D00]">
					{total === 1
						? 'A field does not match the recorded data.'
						: 'Some fields do not match the recorded data.'}
				</p>
			</div>
			<div className="flex items-center gap-2">
				<p className="tabular-nums text-sm font-semibold text-[#BB4D00]">
					{total === 0 ? '0 / 0' : `${currentIndex + 1} / ${total}`}
				</p>
				<button
					type="button"
					aria-label="Previous mismatch"
					disabled={isFirst || total === 0}
					onClick={onPrev}
					className="flex size-7 items-center justify-center disabled:opacity-50 bg-[#F59E0B26] text-[#BB4D00] rounded-full"
				>
					<ChevronLeft className="size-4" />
				</button>
				<button
					type="button"
					aria-label="Next mismatch"
					disabled={isLast || total === 0}
					onClick={onNext}
					className="flex size-7 items-center justify-center disabled:opacity-50 bg-[#F59E0B26] text-[#BB4D00] rounded-full"
				>
					<ChevronRight className="size-4" />
				</button>
			</div>
		</div>
	);
};

export default MismatchBanner;
